<template>
  <div class="pd1-handbook">
    <iframe
      :src="url"
      frameborder="0"
    ></iframe>
  </div>
</template>

<script>
export default {
  data() {
    return {
      url: "https://circle-his.oss-cn-shanghai.aliyuncs.com/DataCenterPro/PD1/common/PD-1.pdf",
    };
  },
  created() {
    const { query } = this.$route;
    if (query.pd1_service_subtype === "垫付版") {
      this.url =
        "https://circle-his.oss-cn-shanghai.aliyuncs.com/DataCenterPro/PD1/common/handbook_dianfu.pdf";
    }
  },
};
</script>

<style lang="scss" scoped>
.pd1-handbook {
  width: 100%;
  height: 100%;
  iframe {
    width: 100%;
    height: 100%;
  }
}
</style>